import { TemplateRef } from '@angular/core';
import { HeaderItemLocation } from './header-item-location';

export class HeaderItem {
  constructor(
    public id: string,
    public templateRef: TemplateRef<any>,
    public location: HeaderItemLocation,
    public priority = 1
  ) {}
}
